import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Mime } from '@shared/api/common/mime-type';
import { AVATAR_MIME_TYPES, AVATAR_MIME_TYPES_STR } from '@shared/api/identity/models/avatar';
import { FileUtil } from '@shared/utils/file.util';

export type ChangeAvatarEvent = {
  /** The content of the file as a data URI. */
  data: string;
}

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  standalone: false
})
export class AvatarComponent {
  @Input() public src = "";
  @Input() public editable = false;
  @Input() public disabled = false;
  @ViewChild('avatarInput', { static: true }) avatarInput: ElementRef<HTMLInputElement>;
  @Output() changeAvatar = new EventEmitter<ChangeAvatarEvent>(false);
  public readonly accept = AVATAR_MIME_TYPES;
  public readonly acceptStr = AVATAR_MIME_TYPES_STR;

  public click() {
    if (this.editable) {
      this.avatarInput.nativeElement.click();
    }
  }

  async onInputChange(event: Event) {
    if (!(event.target instanceof HTMLInputElement)) {
      return;
    }

    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);

    if (!this.accept.includes(file.type as Mime)) {
      return;
    }

    const data = await FileUtil.readFile(file, "dataUrl");
    this.changeAvatar.emit({data});
    this.avatarInput.nativeElement.value = null;
  }

}
